import { StreamChat } from 'stream-chat';
import { StreamMessage } from 'stream-chat-react';
import { v4 as uuidv4 } from 'uuid';

export const createMessagePreview = (client: StreamChat, text: string) => {
    const messageId = `${client.userID}-${uuidv4()}`;

    return {
        __html: text,
        created_at: new Date(),
        html: text,
        id: messageId,
        status: 'sending',
        text,
        type: 'regular',
        user: client.user,
    } as unknown as StreamMessage;
};
